<gp-illustrated-message *ngIf="taskError" [width]="'70%'"
                        [type]="'NO_ACCESS'"
                        [text]="taskError">
</gp-illustrated-message>
<div *ngIf="descriptorLoading" class="text-center">
  <em class="fa fa-light fa-spinner fa-spin spinner"></em>
</div>
<form *ngIf="!taskError" novalidate >

  <div *ngFor="let field of formModel.fields" id="fieldContainer_{{field.id}}" class="col-flex">
    <gp-workflow-form-element
      [field]="field"
      [taskDefinitionKey]="taskDefinitionKey"
      (errorTriggered)="setError($event)"
      [descriptorLoading] = descriptorLoading
      (loadingEnded) = setLoading()
      (requestUpdate)="onRequestUpdate($event)">
    </gp-workflow-form-element>
  </div>

  <div *ngIf="!formModel.outcomes.length && !descriptorLoading" class="form-footer btn-bar btn-bar-sm btn-bar-align-end">
    <button type="button" test-id='workflows-forms-cancel'
            class="btn dark-white p-x-md"
            (click)="close()">
      {{ 'FORMS.cancel' | translate }}
    </button>
    <button type="button" test-id='workflows-forms-submit'
            class="btn primary p-x-md"
            (click)="onSubmitForm()">
      {{ 'FORMS.submit' | translate }}
    </button>
  </div>

  <div *ngIf="formModel.outcomes.length && !descriptorLoading" class="form-footer btn-bar btn-bar-sm btn-bar-align-end">
    <button *ngFor="let outcome of formModel.outcomes"
            type="button" [attr.test-id]="outcome.name"
            class="btn primary p-x-md"
            [disabled]="outcome.enabled === false"
            (click)="onSubmitForm(outcome)">
      {{ outcome.id ? (FORM_OUTCOME_TRANSLATE_PREFIX + outcome.id | translate) : outcome.name }}
    </button>
  </div>
</form>
